import { render, staticRenderFns } from "./POSparepart.vue?vue&type=template&id=e5607ffa&scoped=true"
import script from "./POSparepart.vue?vue&type=script&lang=js"
export * from "./POSparepart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5607ffa",
  null
  
)

export default component.exports